import React, { Component } from "react"
import { Button, FormControl, Modal, OverlayTrigger, Spinner } from "react-bootstrap"
import PortalRoleTemplateWithLnksTypes from "../../types/portalTemplateTypes/PortalRoleTemplateWithLnksTypes"
import TemplateManagementAddOrEditTemplateRoleList from "../TemplateManagementAddOrEditTemplateRoleList/TemplateManagementAddOrEditTemplateRoleList"
import ratmService from "../../utils/RATMService"
import mutate from "../../utils/Mutate"
import ratmCrud from "../../utils/RATMCrud"
import auditTemplate from "../../utils/AuditTemplate"
import cloneRoleTemplate from "../../utils/CloneRoleTemplate"
import ratmPopover from "../../utils/RATMPopover"
import searchRolesAndAssignments from "../../utils/SearchRolesAndAssignments"
import ratmTooltip from "../../utils/RATMTooltip"
import "./TemplateManagementAddOrEditTemplate.css"

interface State {
    eventKeys: string[],
    templateToAddOrEdit: PortalRoleTemplateWithLnksTypes
    addedRoleIds: number[]
}

class TemplateManagementAddOrEditTemplate extends Component<{}, State> {

    state = {
        eventKeys: [],
        templateToAddOrEdit: cloneRoleTemplate(ratmService.state.addOrEditTemplateId),
        addedRoleIds: [],
    }

    componentDidMount(): void {
        this.setTitleText(this.state.templateToAddOrEdit.Template.Name)
    }

    manageThisState = (keys: { key: string, value?: any }[]) => {
        this.setState(mutate(this.state, keys))
    }

    handleChange = (event: { target: { value: any } }) => {
        const input = event.target.value
        const { eventKeys, templateToAddOrEdit } = this.state
        let ttaoe = templateToAddOrEdit
        //@ts-ignore
        ttaoe[eventKeys[0]][eventKeys[1]] = input
        this.manageThisState([{ key: "templateToAddOrEdit", value: ttaoe }])
    }

    buildIssuesArray = (templateStatus: { canSave: boolean, forbiddedRoles: string[], missingName: boolean, missingDescription: boolean }) => {
        return [
            ...templateStatus.missingName ? ["Missing name"] : [],
            ...templateStatus.missingDescription ? ["Missing description"] : [],
            ...templateStatus.forbiddedRoles.map(fb => `${fb} (not allowed)`)
        ]
    }

    setTitleText = (title: string) => {
        const { state } = ratmService
        const { addOrEditTemplateId } = state
        const titleText = `${addOrEditTemplateId < 1 ? "Add a new template" : `Edit: ${title}`}`
        let elem = document.getElementById("eb3aa3b982d64629816af25ea6e448c5")
        if (elem) {
            elem.innerHTML = titleText
        }
    }

    render() {

        const { state, manageState } = ratmService
        const { updatePortalTemplates, addPortalTemplates } = ratmCrud
        const { addOrEditTemplateId, searchInput, busyId } = state//ratmService.state
        const { templateToAddOrEdit } = this.state//this.state
        const templateStatus = auditTemplate(templateToAddOrEdit)

        // console.log("TemplateManagementAddOrEditTemplate state", this.state)

        return (
            <div className="TemplateManagementAddOrEditTemplate">
                <Modal
                    id="af7a0c3196488b93fa0fd07d2a5afa"
                    show={true}
                    backdrop="static"
                    keyboard={true}
                    centered={true}
                    //@ts-ignore
                    size="xl"
                >
                    <Modal.Header>
                        <div className="TemplateManagementAddOrEditTemplateModalHeader">
                            {/************************************step0****************************************/}
                            <div className="TemplateManagementAddOrEditTemplateModalHeaderStep0">
                                <div className="TemplateManagementAddOrEditTemplateModalHeaderStep0Left">
                                    <div className="f838e68cd7de4dd8938bad30ffb71651">
                                        <FormControl
                                            placeholder={searchInput || "Search roles"}
                                            onChange={searchRolesAndAssignments}
                                            value={searchInput || ""}
                                        />
                                    </div>
                                </div>
                                <div className="TemplateManagementAddOrEditTemplateModalHeaderStep0Middle">
                                    <p id="eb3aa3b982d64629816af25ea6e448c5"></p>
                                </div>
                                <div className="TemplateManagementAddOrEditTemplateModalHeaderStep0Right">
                                    {templateStatus.forbiddedRoles.length > 0 &&
                                        <OverlayTrigger placement="bottom" overlay={ratmPopover("Protected roles are not allowed in an unprotected template", templateStatus.forbiddedRoles)}>
                                            <div className="TemplateManagementAddOrEditTemplateValidationWarning">
                                                <span className="material-icons">priority_high</span>
                                            </div>
                                        </OverlayTrigger>}
                                    <div className="TemplateManagementAddOrEditTemplateIsProtected"
                                        onClick={() => {
                                            let ttaoe = templateToAddOrEdit
                                            ttaoe.Template.IsProtected = !ttaoe.Template.IsProtected
                                            this.manageThisState([{ key: "templateToAddOrEdit", value: ttaoe }])
                                        }}
                                    >
                                        <p>Protected</p>
                                        <FormControl
                                            checked={templateToAddOrEdit.Template.IsProtected}
                                            onChange={() => null}
                                            type="checkbox"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="TemplateManagementAddOrEditTemplateModalBody">
                            {/************************************step0****************************************/}
                            <div className="TemplateManagementAddOrEditTemplateModalBodyStep0">
                                <div className="TemplateManagementAddOrEditTemplateModalBodyStep0InputItem">
                                    <div className="TemplateManagementAddOrEditTemplateModalBodyStep0InputItemHeader">
                                        <p>Name</p>
                                        {templateStatus.missingName &&
                                            <OverlayTrigger placement="right" overlay={ratmTooltip("Missing name")}>
                                                <div className="TemplateManagementAddOrEditTemplateValidationWarning">
                                                    <span className="material-icons">priority_high</span>
                                                </div>
                                            </OverlayTrigger>}
                                    </div>
                                    <FormControl
                                        onFocus={() => this.manageThisState([{ key: "eventKeys", value: ["Template", "Name"] }])}
                                        placeholder={templateToAddOrEdit.Template.Name || ""}
                                        onChange={this.handleChange}
                                        value={templateToAddOrEdit.Template.Name || ""}
                                        maxLength={40}
                                    />
                                </div>
                                <div className="TemplateManagementAddOrEditTemplateModalBodyStep0InputItem">
                                    <div className="TemplateManagementAddOrEditTemplateModalBodyStep0InputItemHeader">
                                        <p>Template description</p>
                                        {templateStatus.missingDescription &&
                                            <OverlayTrigger placement="right" overlay={ratmTooltip("Missing description")}>
                                                <div className="TemplateManagementAddOrEditTemplateValidationWarning">
                                                    <span className="material-icons">priority_high</span>
                                                </div>
                                            </OverlayTrigger>}
                                    </div>
                                    <FormControl
                                        className="d0c564b742b1b08d7cf22ea65b02"
                                        onFocus={() => this.manageThisState([{ key: "eventKeys", value: ["Template", "Description"] }])}
                                        placeholder={templateToAddOrEdit.Template.Description || ""}
                                        onChange={this.handleChange}
                                        value={templateToAddOrEdit.Template.Description || ""}
                                        as="textarea"
                                        rows={4}
                                        maxLength={1000}
                                    />
                                </div>
                            </div>

                            {/************************************step1****************************************/}
                            <div className="TemplateManagementAddOrEditTemplateModalBodyStep1">
                                <TemplateManagementAddOrEditTemplateRoleList templateToAddOrEdit={templateToAddOrEdit} />
                            </div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="TemplateManagementAddOrEditTemplateModalFooter">
                            <div className="TemplateManagementAddOrEditTemplateModalFooterLeft">
                                <Button variant="secondary" onClick={async () => {
                                    manageState([{ key: "addOrEditTemplateId", value: -1 }])
                                }}>Quit</Button>
                            </div>
                            <div className="TemplateManagementAddOrEditTemplateModalFooterRight">
                                {busyId !== 2 &&
                                    <div className="TemplateManagementAddOrEditTemplateModalFooterRightNotBusy">
                                        <div className="TemplateManagementAddOrEditTemplateModalFooterRightStep0">
                                        </div>
                                        <div className="TemplateManagementAddOrEditTemplateModalFooterRightStep1">
                                            {!templateStatus.canSave &&
                                                <OverlayTrigger placement="top" overlay={ratmPopover("Issues:", this.buildIssuesArray(templateStatus))}>
                                                    <div className="TemplateManagementAddOrEditTemplateValidationWarning e25fc5728e04e5097c0616e04b5743c">
                                                        <span className="material-icons">error_outline</span>
                                                    </div>
                                                </OverlayTrigger>}
                                            <Button
                                                id={`${templateStatus.canSave ? "6534bc1e245d4b041aec0c71007a9" : "a084fbbb1504a878da60c62ff583c86"}`}
                                                onClick={() =>
                                                    addOrEditTemplateId > 0
                                                        ? updatePortalTemplates(templateToAddOrEdit)
                                                        : addPortalTemplates(templateToAddOrEdit)
                                                }
                                                disabled={!templateStatus.canSave}
                                            >Save
                                            </Button>
                                        </div>
                                    </div>
                                }
                                {busyId === 2 &&
                                    <div className="TemplateManagementAddOrEditTemplateModalFooterRightBusy">
                                        <Spinner className="fc5773659914f0f94dbaebcf0a3ce56" animation="border" />
                                    </div>
                                }
                            </div>
                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default TemplateManagementAddOrEditTemplate